/* eslint-disable import/no-anonymous-default-export */
const WATCHLIST = "WATCHLIST";
const FILMDETAILS = "FILMDETAILS";
const PLAYER = "PLAYER";
const SEEKER = "SEEKER";
const MOVIELIST = "MOVIELIST";
const SEARCHMOVIE = "SEARCHMOVIE";
const WATCHPARTY = "WATCHPARTY";
const CREATEWATCHPARTY = "CREATEWATCHPARTY";
const EDITVIDEO = "EDITVIDEO";
const PREVIEWVIDEO = "PREVIEWVIDEO";
const UPLOAD = "UPLOAD";
const HOME = "HOME";

export default {
  WATCHLIST,
  FILMDETAILS,
  PLAYER,
  SEEKER,
  MOVIELIST,
  SEARCHMOVIE,
  WATCHPARTY,
  UPLOAD,
  PREVIEWVIDEO,
  EDITVIDEO,
  HOME,
};
